// @flow
import React from 'react';
import styled from 'styled-components';
import LinearProgress from 'material-ui/LinearProgress';

import { Currency } from 'common/components/Number';
import translate from 'react-i18next/dist/commonjs/translate';
import SalesEstimationNotification from '../../domain/SalesEstimationNotification';

const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  flex: 2;
`;

const Title = styled.div`
  padding: ${({ theme }) => theme.metrics.tinyMargin}px 0;
  margin-bottom: ${({ theme }) => theme.metrics.tinyMargin}px;
`;

const Message = styled.div`
  font-size: 14px;
`;

const TotalCost = styled(Message)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;

  margin-top: ${({ theme }) => theme.metrics.smallMargin}px;
`;

function SalesNotificationProgressComponent({ notification, t }: { notification: SalesEstimationNotification, t: any }) {
  return (
    <Wrapper>
      <Title>
        {t('notifications.estimating.title')}
        <LinearProgress />
      </Title>
      <Message>{t('notifications.estimating.message')}</Message>
    </Wrapper>
  );
}

function SalesNotificationErrorComponent({ notification, t }: { notification: SalesEstimationNotification, t: any }) {
  return (
    <Wrapper>
      <Title>{t('notifications.error.title')}</Title>
      <Message>{t('notifications.error.message')}</Message>
    </Wrapper>
  );
}

function SalesNotificationSuccessComponent({ notification, t }: { notification: SalesEstimationNotification, t: any }) {
  return (
    <Wrapper>
      <Title>{t('notifications.success.title')}</Title>
      <Message>{t('notifications.success.message')}</Message>
      <TotalCost><Currency value={notification.getTotalCost()} /></TotalCost>
    </Wrapper>
  );
}

const SalesNotificationProgress = translate('sales')(SalesNotificationProgressComponent);
const SalesNotificationSuccess = translate('sales')(SalesNotificationSuccessComponent);
const SalesNotificationError = translate('sales')(SalesNotificationErrorComponent);

export { SalesNotificationProgress, SalesNotificationSuccess, SalesNotificationError };



// WEBPACK FOOTER //
// ./src/statsradio/modules/notifications/components/salesNotifications/SalesNotificationStates.js